function normalizeText(str) {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");
}

function stripSpaces(str) {
  return str.replace(/\s+/g, "");
}

function extractDigits(str) {
  return str.replace(/\D/g, "");
}

function deobfuscateSpanishEmail(str) {
  return str
    .replace(/\b(arroba|aroba)\b/gi, "@")
    .replace(/\bpunto\b/gi, ".");
}

function checkEmail(message, email) {
  if (!email) return false;
  const emailLower = email.toLowerCase();

  if (stripSpaces(message).toLowerCase().includes(emailLower)) return true;

  const deobfuscated = deobfuscateSpanishEmail(message);
  if (stripSpaces(deobfuscated).toLowerCase().includes(emailLower)) return true;

  return false;
}

function checkPhone(message, phoneDigits) {
  if (!phoneDigits || phoneDigits.length < 7) return false;

  const messageDigits = extractDigits(message);
  if (messageDigits.length < phoneDigits.length) return false;

  if (messageDigits.includes(phoneDigits)) return true;

  const reversed = phoneDigits.split("").reverse().join("");
  if (messageDigits.includes(reversed)) return true;

  return false;
}

function checkAddress(message, addressTokens) {
  if (!addressTokens || addressTokens.length === 0) return false;

  const normalized = normalizeText(message);
  return addressTokens.some((token) => normalized.includes(token));
}

export function extractUserPII(athleteData, scoutData) {
  const rawEmail = athleteData?.email || scoutData?.email || null;
  const rawPhone =
    athleteData?.attributes?.phone || scoutData?.phone || null;
  const rawAddress =
    athleteData?.attributes?.city ||
    scoutData?.details?.organization_info?.address ||
    null;

  const email = rawEmail ? rawEmail.toLowerCase().trim() : null;

  const phoneDigits = rawPhone ? extractDigits(String(rawPhone)) : null;
  const phone = phoneDigits && phoneDigits.length >= 7 ? phoneDigits : null;

  let addressTokens = [];
  if (rawAddress) {
    addressTokens = normalizeText(String(rawAddress))
      .split(/[\s,]+/)
      .filter((t) => t.length >= 4);
  }

  return { email, phone, addressTokens };
}

export function containsPersonalData(message, pii) {
  if (!message || !pii) return { blocked: false, reason: null };

  if (checkEmail(message, pii.email)) {
    return {
      blocked: true,
      reason:
        "Tu mensaje contiene tu correo electrónico. Por tu seguridad, no compartas datos personales en el chat.",
    };
  }

  if (checkPhone(message, pii.phone)) {
    return {
      blocked: true,
      reason:
        "Tu mensaje contiene tu número de teléfono. Por tu seguridad, no compartas datos personales en el chat.",
    };
  }

  if (checkAddress(message, pii.addressTokens)) {
    return {
      blocked: true,
      reason:
        "Tu mensaje contiene información de tu dirección. Por tu seguridad, no compartas datos personales en el chat.",
    };
  }

  return { blocked: false, reason: null };
}
